import omit from "lodash/omit";
import React from "react";
import { BASE_ELEMENT_IGNORED_FIELDS } from "../types/popoverProps";
import withTooltip from "../withTooltip";
export default withTooltip((props) => (React.createElement("i", { ...omit(props, BASE_ELEMENT_IGNORED_FIELDS) })));
